



































































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import ModalDialog from '@/components/ModalDialog.vue';

import InternalBillingList from './InternalBillingList.vue';
import InternalDetailTraffic from './InternalDetailTraffic.vue';
import InternalBillingSummary from './InternalBillingSummary.vue';

import numberFormat from '@/libs/numberFormat';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Modal,
    Button,
    ModalDialog,

    InternalBillingList,
    InternalDetailTraffic,
    InternalBillingSummary,
  },
  methods: {
    numberFormat,
  }
})

export default class InternalDetail extends Vue {
  // mounted() {
  //   console.log('mounted', this.$store.state.user.user); // contoh ambil data dari store
  // }

  numberFormat!: typeof numberFormat;

  internalDisagree = false;
  showConfirmation = false;
  dialogAgree = false;
  dialogDisagree = false;
  dialogConfirm = false;
  dialogApprove = false;
  dialogDecline = false;

  selectedPeriod: any = {};
  trafficPerDay: any[] = [];
  trafficDetail: any = {};

  submittedData: any;

  $refs!: {
    detailTraffic: InternalDetailTraffic;
    billingList: InternalBillingList;
    billingSummary: InternalBillingSummary;
  }

  handleSelectPeriod(data: any) {
    // console.log('selected', data);
    this.selectedPeriod = data;
    this.selectedPeriodChange(data);
    this.internalDisagree = false;
  }

  async selectedPeriodChange(payload: any) {
    if (payload.merchant_traffic) {
      const { data } = await api.get(`recon/traffic/${payload.merchant_code
        }/${payload.merchant_traffic.credential_code
        }/${payload.merchant_traffic.periode_slug}`);
      if (data.data) {
        this.trafficPerDay = data.data.traffic_per_day;
        if (/0|5/.test(payload.merchant_traffic.status)) {
          this.trafficPerDay.forEach((val: any) => {
            val.merchant_traffic = val.sprint_traffic;
            val.merchant_amount = val.amount;
          })
        }
      }
    }
  }

  handleSummaryButtonClick(buttonType: any, submittedData: any) {
    try {
      switch (buttonType) {
        case 'agree': {
          this.dialogAgree = true;
          break;
        }
        case 'disagree': {
          this.dialogDisagree = true;
          break;
        }
        case 'cancelDisagree': {
          this.internalDisagree = false;
          this.$refs.detailTraffic.cancelChange();
          break;
        }
        case 'submit': {
          this.submitData();
          break;
        }
        case 'confirm': {
          this.dialogConfirm = true;
          this.submittedData = submittedData;
          break;
        }
        case 'approve': {
          this.dialogApprove = true;
          break;
        }
        case 'decline': {
          this.dialogDecline = true;
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  submitData() {
    try {
      if (this.internalDisagree) {
        let trafficData: any[] = [];
        this.trafficPerDay.forEach((data: any) => {
          if (data.merchant_traffic != data.sprint_traffic) {
            trafficData.push({
              id: data.id,
              traffic: data.merchant_traffic,
              amount: data.merchant_amount,
            });
          }
        });

        let finalData = new FormData;
        finalData.append('credential', this.selectedPeriod.merchant_traffic.credential_code)
        finalData.append('periode', this.selectedPeriod.merchant_traffic.periode_slug)
        // finalData.append('reason', 'no-reason')
        finalData.append('type', "4")
        if (trafficData.length) {
          finalData.append('data', JSON.stringify(trafficData))
        }
        api.post('recon/traffic/update', finalData).then((result: any) => {
          if (result.data.status) {
            showToast(ToastType.SUCCESS, 'Congratulations!', "Merchant's disclaim has been successfully processed");
            this.$refs.billingList.loadData();
            this.selectedPeriod = {};
            this.internalDisagree = false;
          } else {
            showToast(ToastType.FAILED, 'Process Failed', result.data.message);
          }
        }).catch(() => {
          showToast(ToastType.FAILED, 'Process Failed', 'An Error Occured');
        })
      } else {
        api.post('recon/traffic/update',
          {
            credential: this.selectedPeriod.merchant_traffic.credential_code,
            periode: this.selectedPeriod.merchant_traffic.periode_slug,
            // reason: 'no-reason',
            type: "2",
          }).then((result: any) => {
            console.log('masuk ')
            if (result.data.status) {
              showToast(ToastType.SUCCESS, 'Congratulations!', "Merchant's disclaim has been successfully processed");
              this.$refs.billingList.loadData();
              this.selectedPeriod = {};
            } else {
              showToast(ToastType.FAILED, 'Process Failed', result.data.message);
            }
          }).catch(() => {
            console.log('ada error')
            showToast(ToastType.FAILED, 'Process Failed', 'An Error Occured');
          })
      }
    } catch (error) {
      console.log(error);
    }
  }

  confirmData() {
    try {
      let finalData = new FormData;
      let fileData: any = this.$refs.billingSummary.fileData;
      finalData.append('credential', this.selectedPeriod.merchant_traffic.credential_code);
      finalData.append('periode', this.selectedPeriod.merchant_traffic.periode_slug);
      finalData.append('reason', this.$refs.billingSummary.listReason[this.$refs.billingSummary.selectedReason]);
      if (fileData) {
        finalData.append('file', fileData);
      }

      api.post('recon/traffic/confirm', finalData)
        .then((result: any) => {
          if (result.data.status) {
            showToast(ToastType.SUCCESS, 'Confirm Success', 'Merchant billing has been successfully confirmed');
            this.$refs.billingList.loadData();
            this.selectedPeriod = {};
          } else {
            showToast(ToastType.FAILED, 'Confirm Failed', result.data.message);
          }
        }).catch((error: any) => {
          showToast(ToastType.FAILED, 'Confirm Failed', 'An Error Occured');
        })
    } catch (error) {
      console.log(error);
    }
  }

  approvalData(type: number) {
    try {
      api.post('recon/traffic/update',
        {
          credential: this.selectedPeriod.merchant_traffic.credential_code,
          periode: this.selectedPeriod.merchant_traffic.periode_slug,
          // reason: 'no-reason',
          type: type,
        }).then((result: any) => {
          if (result.data.status) {
            showToast(ToastType.SUCCESS, `${type === 5 ? 'Approval' : 'Decline '} Success`, 'Merchant’s claim has been successfully processed');
            this.$refs.billingList.loadData();
            this.selectedPeriod = {};
          } else {
            showToast(ToastType.FAILED, `${type === 5 ? 'Approval' : 'Decline '} Failed`, result.data.message);
          }
        }).catch(() => {
          console.log('ada error')
          showToast(ToastType.FAILED, `${type === 5 ? 'Approval' : 'Decline '} Failed`, 'An Error Occured');
        })
    } catch (error) {
      console.log(error);
    }
  }
}
